module.exports = __webpack_public_path__ + "static/img/image_charge.4fad92cd.jpg";